/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import ReactPaginate from 'react-paginate';
import $ from 'jquery';
import './style.scoped.scss';

import {
  FaBookmark,
  FaFilter,
  FaSortAmountDown,
  FaSortAmountUpAlt,
  FaTimes,
} from 'react-icons/fa';
import Loader from '../Loader';
import {
  BookmarksColumns,
  ROUTES,
  clearString,
  ListUniqueValues,
} from '../../assets/constants/strings';
import Search from '../Search';
import FilterModal from '../Modals/FilterModal';
import Bookmark from './Bookmark';
import { DeleteBookmarks } from '../../store/User/userActions';
import { getWorkingDocsForBookmarks } from '../../store/Client/clientActions';

const Bookmarks = ({
  bookmarks: globalBookmarks,
  structure,
  documents,
  bookmarkLoading,
  DeleteBookmarks,
  bookmarkDocs,
  getWorkingDocsForBookmarks,
}) => {
  const [bookmarks, setBookmarks] = useState([]);

  const [selectedItems, setSelectedItems] = useState([]);
  const [selectedPage, setSelectedPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [selectedSort, setSelectedSort] = useState('title');
  const [selectedOrder, setSelectedOrder] = useState('>');
  const [refinedList, setRefinedList] = useState(bookmarks);
  const [searchValue, setSearchValue] = useState('');
  const [filterValue, setFilterValue] = useState('');
  const [loadingBookmarks, setLoadingBookmarks] = useState(false);
  const [isSmall, setIsSmall] = useState(window.innerWidth < 750);

  // using refs to ensure the load logic works
  const screenRef = useRef(isSmall);
  screenRef.current = isSmall;

  useEffect(() => {
    // listen for changes in window width for hide/show logic
    window.addEventListener('resize', checkScreenSize);

    return () => {
      window.removeEventListener('resize', checkScreenSize);
    };
  }, []);

  useEffect(() => {
    setLoadingBookmarks(true);
    if (bookmarkDocs === null) getWorkingDocsForBookmarks();
    else {
      if (globalBookmarks && bookmarkDocs && bookmarkLoading === 0) {
        const allBookmarks = [];

        globalBookmarks.forEach((bookmark) => {
          const thisDoc = bookmarkDocs.filter(
            (doc) => doc.slug === bookmark.document
          )[0];

          allBookmarks.push({
            id: bookmark.id,
            pageId: bookmark.page,
            Link: ROUTES.DOCUMENT(bookmark.document, bookmark.page),
            title: bookmark.pageTitle,
            documentName: thisDoc ? thisDoc.title : 'Regulation Title',
            levelOne: thisDoc ? thisDoc.levelOne.Title : structure.LevelOne,
            versionDate:
              thisDoc && thisDoc.versionDate ? thisDoc.versionDate : 'N/A',
          });
        });
        setBookmarks(allBookmarks);
      }
    }
    setLoadingBookmarks(false);
  }, [globalBookmarks, bookmarkDocs]);

  useEffect(() => {
    setRefinedList(bookmarks);
    setSelectedItems([]);
    setSearchValue('');
    setFilterValue('');
  }, [bookmarks]);

  const checkScreenSize = () => {
    screenRef.current = window.innerWidth < 750;
    setIsSmall(screenRef.current);
  };

  const isMobile = window.innerWidth < 415;
  $('[data-toggle="tooltip"]').tooltip();

  const handleSort = (value) => {
    // if (selectedSort === value) handleOrder();
    setSelectedSort(value);
  };

  const handleOrder = () => {
    const currOrder = selectedOrder;
    currOrder === '>' ? setSelectedOrder('<') : setSelectedOrder('>');
  };

  const handleDisplayOrderBtn = (column) => {
    return selectedSort === column ? (
      selectedOrder === '<' ? (
        <p
          className='ml-2 sort-button sort-button__order'
          onClick={handleOrder}
        >
          Desc. <FaSortAmountDown className='ml-2 mr-0' />
        </p>
      ) : (
        <p
          className='ml-2 sort-button sort-button__order'
          onClick={handleOrder}
        >
          Asc. <FaSortAmountUpAlt className='ml-2 mr-0' />
        </p>
      )
    ) : null;
  };

  const pageCount = Math.ceil(bookmarks.length / itemsPerPage);
  const indexOfLastItem = selectedPage * itemsPerPage;
  const indexOfFirstTodo = indexOfLastItem - itemsPerPage;

  const orderedList =
    selectedOrder === '>'
      ? refinedList
          .sort((a, b) =>
            typeof a[selectedSort] === 'string' &&
            typeof b[selectedSort] === 'string'
              ? a[selectedSort].localeCompare(b[selectedSort], undefined, {
                  numeric: true,
                })
              : a[selectedSort] > b[selectedSort]
              ? 1
              : -1
          )
          .slice(indexOfFirstTodo, indexOfLastItem)
      : refinedList
          .sort((a, b) =>
            typeof a[selectedSort] === 'string' &&
            typeof b[selectedSort] === 'string'
              ? b[selectedSort].localeCompare(a[selectedSort], undefined, {
                  numeric: true,
                })
              : a[selectedSort] < b[selectedSort]
              ? 1
              : -1
          )
          .slice(indexOfFirstTodo, indexOfLastItem);

  const handlePaginationClick = (selectedItem) => {
    setSelectedPage(selectedItem.selected + 1);
  };

  const searchBookmarks = (value) => {
    let filteredList = [...bookmarks];

    // first, apply filter, then search
    if (filterValue.length > 0)
      filteredList = filteredList.filter(
        (bookmark) => bookmark.levelOne === filterValue
      );

    if (value.length > 0) {
      value = clearString(value).trim().toLowerCase();

      setRefinedList(
        filteredList.filter(
          (bookmark) =>
            bookmark.title.toLowerCase().match(value) ||
            bookmark.documentName.toLowerCase().match(value) ||
            bookmark.levelOne.toLowerCase().match(value)
        )
      );
    } else {
      setRefinedList(filteredList);
    }
    setSearchValue(value);
  };

  const handleApplyFilter = (DDLName, value) => {
    if (value.length > 0) {
      $('#filterModal').modal('hide');
      setFilterValue(value);
      setRefinedList(bookmarks.filter((item) => item[DDLName] === value));
    } else {
      setFilterValue(value);
      setRefinedList(bookmarks);
    }
  };

  // radio button checked
  const handleSelected = (bookmark) => {
    let ticked = !selectedItems.some((item) => item.id === bookmark.id);

    // add to state if ticked
    if (ticked) setSelectedItems([...selectedItems, bookmark]);
    // remove if unticked
    else
      setSelectedItems((currentState) => [
        ...currentState.filter((itemOnState) => itemOnState.id !== bookmark.id),
      ]);
  };

  const handleSelectedAll = () => {
    if (selectedItems.length === bookmarks.length) setSelectedItems([]);
    else setSelectedItems(bookmarks);
  };

  const handleRemoveSelected = () => {
    DeleteBookmarks(selectedItems);
    setBookmarks([]);
  };

  if (
    bookmarkLoading > 0 ||
    !globalBookmarks ||
    !documents ||
    bookmarkDocs === null ||
    loadingBookmarks
  ) {
    return (
      <div className='col'>
        <Loader text='Loading Bookmarks...' />
      </div>
    );
  }
  return (
    <div className='col bookmarks-frame' id='main-content'>
      {bookmarks.length > 0 ? (
        <React.Fragment>
          <div className='bookmarks-header-row'>
            <b className='results-number m-0'>
              {`${refinedList.length} Bookmark${
                searchValue.length > 0 || filterValue.length > 0
                  ? refinedList.length === 1
                    ? ' found'
                    : 's found'
                  : refinedList.length > 1
                  ? 's saved'
                  : ' saved'
              }`}
            </b>
            <div className='bookmarks-header-row__filter-search'>
              {filterValue.length > 0 ? (
                <div
                  className='sort-button'
                  onClick={() => handleApplyFilter('levelOne', '')}
                  title='Click to remove filter'
                >
                  <FaTimes />
                  <span className='ml-3'>Regulator: {filterValue}</span>
                </div>
              ) : null}
              <Search
                placeholder=' Bookmarks'
                handleSearch={searchBookmarks}
                mobileLg
                clearButton
                searchOnType
              />
            </div>
          </div>
          <div className='bookmarks-wrapper'>
            <div
              className={isSmall ? 'd-flex flex-column' : 'bookmarks-sort-row'}
            >
              {BookmarksColumns(isSmall).map((col, i) => (
                <div className={col.CSS} key={i}>
                  {col.INPUT ? (
                    <input
                      type='checkbox'
                      checked={
                        bookmarks.length > 0 &&
                        selectedItems.length === bookmarks.length
                      }
                      onChange={handleSelectedAll}
                    />
                  ) : null}
                  {/* show filter button only if dropdown only has one option */}
                  {col.FILTER &&
                  ListUniqueValues(bookmarks, 'levelOne', true).length > 1 ? (
                    <div
                      className='sort-button'
                      onClick={() => $('#filterModal').modal('show')}
                    >
                      <FaFilter className='m-0' />
                    </div>
                  ) : null}
                  <p
                    className='sort-button font-weight-bold'
                    title={isMobile ? col.TOOLTIP : 'Click to sort'}
                    data-toggle={isMobile ? 'tooltip' : ''}
                    data-original-title={col.TOOLTIP}
                    onClick={() => handleSort(col.VALUE)}
                  >
                    {/* on larger screens, show text */}
                    {isMobile ? col.DISPLAY.substring(0, 3) : col.DISPLAY}
                  </p>
                  {handleDisplayOrderBtn(col.VALUE)}
                </div>
              ))}
            </div>
            <div className='accordion'>
              {/* foreach document found we want to have a Pagination logic */}
              {orderedList.map((bookmark, i) => (
                <Bookmark
                  key={i}
                  index={i}
                  bookmark={bookmark}
                  isMobile={isMobile}
                  isSelected={selectedItems.some(
                    (item) => item.id === bookmark.id
                  )}
                  handleSelected={handleSelected}
                  isDisabled={bookmark.isDisabled}
                  isSmall={isSmall}
                />
              ))}
            </div>
            {pageCount > 1 && (
              <div className='text-center mt-5'>
                <ReactPaginate
                  onPageChange={handlePaginationClick}
                  previousLabel={'previous'}
                  previousClassName={'paginate-previous'}
                  nextLabel={'next'}
                  nextClassName={'paginate-next'}
                  breakLabel={'...'}
                  breakClassName={'page-item'}
                  breakLinkClassName={'page-link'}
                  pageCount={pageCount}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={10}
                  containerClassName={'pagination pagination-sm'}
                  pageClassName={'page-item'}
                  pageLinkClassName={'page-link'}
                  activeClassName={'page-item active'}
                />
              </div>
            )}
            {selectedItems.length > 0 ? (
              <button className='my-account-btn' onClick={handleRemoveSelected}>
                Remove
              </button>
            ) : null}
          </div>
          <FilterModal
            DDLName='levelOne'
            modalText='Regulator:'
            handleApplyFilter={handleApplyFilter}
            options={ListUniqueValues(bookmarks, 'levelOne', true)}
          />
        </React.Fragment>
      ) : (
        <div className='col main-content-wrapper' key={'index'}>
          <div className='card empty'>
            <div className='card-header font-weight-bold'>
              To create a bookmark, click on the bookmark icon ( <FaBookmark />{' '}
              ) next to the heading. This content will then be saved in your
              bookmarks list until such time as you delete the bookmark.
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  bookmarks: state.user.bookmarks,
  bookmarkLoading: state.user.bookmarkLoading,
  // pages: state.client.pages,
  documents: state.client.documents,
  user: state.user.user,
  structure: state.client.spStructure,
  bookmarkDocs: state.client.bookmarksDocs,
});

const mapDispatchToProps = {
  DeleteBookmarks,
  getWorkingDocsForBookmarks,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export default connector(Bookmarks);
